import React from 'react';
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemIcon
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListItemText from '@mui/material/ListItemText';
import { getNonAffiliateLink, parseTitle } from '@utils/index';
import { useGetDealsByUnmappedCategory } from '@hooks/useBrowseNodeCategories';
import AdminActions from '@components/AdminActions';

interface ShowDealsFromBrowseNodeMappingProps {
  categoryId: string;
  defaultExpanded?: boolean;
}

const ShowDealsFromBrowseNodeMapping: React.FC<
  ShowDealsFromBrowseNodeMappingProps
> = ({ categoryId, defaultExpanded = false }) => {
  const { data: deals, isLoading } = useGetDealsByUnmappedCategory(categoryId);

  if (isLoading) {
    return <Box>Loading...</Box>;
  }

  return (
    <Box>
      <Accordion defaultExpanded={defaultExpanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography
            variant="body1"
            gutterBottom
          >{`${deals.length} deals total`}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List>
            {(deals || []).map((deal) => (
              <ListItem key={deal?.ASIN}>
                <ListItemAvatar>
                  <IconButton
                    edge="start"
                    aria-label="see item in browse node mapping"
                    onClick={() => {
                      window.open(getNonAffiliateLink(deal.ASIN), '_blank');
                    }}
                  >
                    <Avatar
                      alt={parseTitle(deal.title)}
                      src={deal.image100Url || deal.image240Url || deal.image}
                      variant="square"
                      sx={{ width: 50, height: 50 }}
                    />
                  </IconButton>
                </ListItemAvatar>
                <ListItemText primary={parseTitle(deal?.title)} />
                <ListItemIcon>
                  <AdminActions ASIN={deal.ASIN} deal={deal} />
                </ListItemIcon>
              </ListItem>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ShowDealsFromBrowseNodeMapping;
